export enum EstadoPedido {
    Abierto = 0,
    Cerrado = 1,
    Anulado = 2,
}


